/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function ArrowIcon({ width = 11.7, height = 20, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.7"
      height="20"
      viewBox="0 0 11.775 20"
      {...props}
    >
      <path
        id="arrow_forward_ios_FILL0_wght400_GRAD0_opsz24"
        d="M8.025,22,6.25,20.225,14.475,12,6.25,3.775,8.025,2l10,10Z"
        transform="translate(-6.25 -2)"
      />
    </svg>
  );
}

export default ArrowIcon;
